import { AUTH_METHOD } from "@/shared/constants/authMethods"
import { LOGIN_PATH } from "@/shared/constants/routePaths"
import { useAuth } from "@/shared/hooks/useAuth"
import { ErrorComponent } from "../../ErrorComponent/ErrorComponent"
import { Loading } from "../../Loading/Loading"
import { AuthenticatedRouter } from "../AuthenticatedRouter/AuthenticatedRouter"
import { UnauthenticatedRouter } from "../UnauthenticatedRouter"

export function Router() {
  const auth = useAuth()

  if (auth.type === AUTH_METHOD.COOKIE) {
    const { isLoading, isError, error, refetch, user } = auth

    if (isLoading) {
      return <Loading />
    }

    if (isError) {
      return (
        <ErrorComponent
          onRetry={() => {
            refetch()
          }}
          error={error}
        />
      )
    }

    return user ? <AuthenticatedRouter /> : <UnauthenticatedRouter />
  }

  // MSAL auth
  const { isLoading, isError, error, user } = auth

  if (isLoading) {
    return <Loading />
  }

  if (isError && error) {
    return (
      <ErrorComponent
        onRetry={() => {
          // Redirect to login page to retry MSAL authentication
          window.location.href = LOGIN_PATH
        }}
        error={error}
      />
    )
  }

  return user ? <AuthenticatedRouter /> : <UnauthenticatedRouter />
}
